const METHOD_LABELS = { cash: 'מזומן', check: 'שיק', transfer: 'העברה', credit: 'אשראי' };
const money = (v) => `₪${(parseFloat(v) || 0).toFixed(2)}`;
const esc = (v) => String(v ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

export const methodLabel = (m) => METHOD_LABELS[m] || m || '-';

// items: [{ name, quantity, price, cost }], payments: [{ method, amount, checkNumber, notes }]
export const buildDocumentHtml = ({ title, customerName, customerNumber, date, items = [], payments = [], total, vatRate = 0, showCost = false, extraInfo = [], docNumber = null, autoPrint = true }) => {
  const subtotal = total ?? items.reduce((s, i) => s + (parseFloat(i.quantity) || 0) * (parseFloat(i.price) || 0), 0);
  const rate = parseFloat(vatRate) || 0;
  const vat = subtotal * rate / 100;
  const itemsTotal = subtotal + vat;
  const paid = payments.reduce((s, p) => s + (parseFloat(p.amount) || 0), 0);
  const balance = itemsTotal - paid;
  const costTotal = items.reduce((s, i) => s + (parseFloat(i.quantity) || 0) * (parseFloat(i.cost) || 0), 0);
  const rows = items.map((i) => `<tr><td>${esc(i.name)}</td><td class="c">${esc(i.quantity)}</td>${showCost ? `<td class="c">${money(i.cost)}</td>` : ''}<td class="c">${money(i.price)}</td><td class="c b">${money((parseFloat(i.quantity) || 0) * (parseFloat(i.price) || 0))}</td></tr>`).join('');
  const sumRows = `<table class="sum"><tbody>
<tr><td>סה"כ לפני מע"מ</td><td class="c">${money(subtotal)}</td></tr>
<tr><td>${rate ? `מע"מ ${rate}%` : 'מע"מ (פטור)'}</td><td class="c">${money(vat)}</td></tr>
<tr class="b"><td>סה"כ לתשלום</td><td class="c">${money(itemsTotal)}</td></tr>
${showCost ? `<tr><td>סה"כ עלות</td><td class="c">${money(costTotal)}</td></tr><tr><td>רווח (לפני מע"מ)</td><td class="c">${money(subtotal - costTotal)}</td></tr>` : ''}
</tbody></table>`;
  const payRows = payments.map((p) => `<tr><td>${esc(methodLabel(p.method))}</td><td class="c b">${money(p.amount)}</td><td>${p.checkNumber ? `שיק #${esc(p.checkNumber)} ` : ''}${esc(p.notes)}</td></tr>`).join('');
  const html = `<!DOCTYPE html><html dir="rtl" lang="he"><head><meta charset="utf-8"><title>${esc(title)} - ${esc(customerName)}</title>
<style>
body{font-family:Arial,sans-serif;padding:24px;color:#111}
.head{text-align:center;border-bottom:2px solid #1e40af;padding-bottom:10px;margin-bottom:16px}
.head h1{color:#1e40af;margin:0 0 4px}
.head p{margin:2px 0;font-size:12px;color:#4b5563}
h2{text-align:center;color:#1e40af;margin:8px 0 14px}
.info{display:flex;gap:28px;flex-wrap:wrap;background:#f3f4f6;border-radius:8px;padding:10px 14px;margin-bottom:16px;font-size:14px}
.info span{font-weight:bold}
table{width:100%;border-collapse:collapse;margin-bottom:16px;font-size:13px}
th{background:#1e40af;color:#fff;padding:8px;border:1px solid #d1d5db}
td{padding:7px;border:1px solid #d1d5db}
.c{text-align:center}.b{font-weight:bold}
.tot{display:flex;justify-content:space-between;font-size:16px;font-weight:bold;border-top:2px solid #111;padding-top:8px}
.sum{width:320px;margin-right:auto;margin-left:0}
.sum td{padding:6px 10px}
.sum tr.b td{font-size:15px;background:#eef2ff}
.foot{text-align:center;font-size:11px;color:#9ca3af;margin-top:30px}
</style></head><body>
<div class="head"><h1>אימן שירותי מחשוב</h1><p>התקנת רשתות תקשורת | מכירה והתקנת מחשבים נייחים וניידים | מצלמות ומעגל סגור | אינטרקומים</p><p>aiman@aimanpc.com | 052-576-7555</p></div>
<h2>${esc(title)}${docNumber ? ` <span style="font-size:16px;color:#374151">| מסמך מס' ${esc(docNumber)}</span>` : ''}</h2>
<div class="info"><div>לקוח: <span>${esc(customerName)}</span></div>${customerNumber ? `<div>מספר לקוח: <span>${esc(customerNumber)}</span></div>` : ''}<div>תאריך: <span>${esc(date ? new Date(date).toLocaleDateString('he-IL') : '')}</span></div>${extraInfo.map(([k, v]) => v ? `<div>${esc(k)}: <span>${esc(v)}</span></div>` : '').join('')}</div>
<table><thead><tr><th>פריט / עבודה</th><th>כמות</th>${showCost ? '<th>מחיר עלות</th>' : ''}<th>מחיר</th><th>סה"כ</th></tr></thead><tbody>${rows || `<tr><td colspan="${showCost ? 5 : 4}" class="c">אין פריטים</td></tr>`}</tbody></table>
${sumRows}
${payments.length ? `<table><thead><tr><th>אמצעי תשלום</th><th>סכום</th><th>הערות</th></tr></thead><tbody>${payRows}</tbody></table>` : ''}
<div class="tot"><div>סה"כ כולל מע"מ: ${money(itemsTotal)}</div><div>שולם: ${money(paid)}</div><div>${balance > 0.01 ? `יתרה לתשלום: ${money(balance)}` : 'שולם במלואו'}</div></div>
<div class="foot">הופק בתאריך: ${new Date().toLocaleDateString('he-IL')}</div>
${autoPrint ? '<script>window.onload=function(){window.print();}</script>' : ''}
</body></html>`;
  return html;
};

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const jsonHeaders = () => ({ 'Content-Type': 'application/json', ...(localStorage.getItem('authToken') ? { Authorization: `Bearer ${localStorage.getItem('authToken')}` } : {}) });

export const getDocNumber = async (docRef) => {
  if (!docRef?.recordId) return null;
  const res = await fetch(`${API}/documents/number`, { method: 'POST', headers: jsonHeaders(), credentials: 'include', body: JSON.stringify({ type: docRef.type, recordId: docRef.recordId }) });
  return res.ok ? (await res.json()).number : null;
};

// Opens the window synchronously (avoids popup blockers), then fills it after the number arrives
export const printDocument = (opts) => {
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.write('<html dir="rtl"><body style="font-family:Arial;padding:40px">טוען מסמך...</body></html>');
  getDocNumber(opts.docRef).catch(() => null).then((docNumber) => {
    w.document.open();
    w.document.write(buildDocumentHtml({ ...opts, docNumber }));
    w.document.close();
  });
  return true;
};

export const shareDocument = async (opts) => {
  const docNumber = await getDocNumber(opts.docRef).catch(() => null);
  const html = buildDocumentHtml({ ...opts, showCost: false, docNumber, autoPrint: false });
  const title = `${opts.title}${docNumber ? ` מס' ${docNumber}` : ''} - אימן שירותי מחשוב`;
  const res = await fetch(`${API}/documents/share`, { method: 'POST', headers: jsonHeaders(), credentials: 'include', body: JSON.stringify({ html, origin: window.location.origin, title }) });
  if (!res.ok) throw new Error('share failed');
  return { ...(await res.json()), title };
};

export const emailDocument = async (token, email, customerName) => {
  const res = await fetch(`${API}/documents/email`, { method: 'POST', headers: jsonHeaders(), credentials: 'include', body: JSON.stringify({ token, email, customerName }) });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || 'שליחת המייל נכשלה');
};
